module.exports = __webpack_public_path__ + "img/home-bg-image.8c2fb4fc.jpg";